<template>
  <el-drawer @reload="$reloadHandle"
             title="工单打印" size="80%"
             :before-close="handleClose"
             :visible.sync="drawer"
             direction="rtl"
             :modal-append-to-body="true"
             custom-class="demo-drawer"
             ref="drawer"
  >
    <div style="margin-top: 20px; text-align: center">
      <button @click="print()">打印</button>
    </div>
  <div id="print">
    <div id="divPrint" class="mainbox print" v-for="(order,index) in orderDates" style="page-break-after:always">
      <div class="container">
        <div class="top-img">
          <div><img src="statics/images/vatti.png"></div>
          <div class="title"  v-if="order.serviceType ==1">华帝产品安装服务单据</div>
          <div class="title"  v-if="order.serviceType !=1">华帝产品维修服务单据</div>
          <div><img src="statics/images/vatti2.png" ></div>

        </div>
        <div class="top2">
          <div><span class="span1">服务网点名称</span>:  <span class="span2">{{order.siteName}}</span></div>
          <div><span class="span1">工单号</span>:  <span class="span2">{{order.orderNo}}</span></div>
          <div><span class="span1">打印日期</span>:  <span class="span2">{{nowDate}}</span></div>



        </div>

        <table border="1">
          <tbody>
          <tr>
            <th colspan="2"  rowspan="1" class="wid100" style="width: 23%"><span style="margin-left: 5px;">用户姓名：{{order.userName}}</span></th>
            <th colspan="5"  rowspan="1" class="wid180" style="width: 50%"><span style="margin-left: 5px;">联系方式：{{order.userMobile}}</span></th>
            <th colspan="3"  rowspan="1"  class="wid100" style="width: 30%"><span style="margin-left: 5px;">条形码：</span></th>
          </tr>
          <tr>
            <th colspan="2"  rowspan="1" class="wid100" style="width: 20%"><span style="margin-left: 5px;">购买时间：{{order.buyDate}}</span></th>
            <th colspan="3"  rowspan="1" class="wid180" style="width: 30%"><span style="margin-left: 5px;">购买地点：{{order.buyShop}}</span></th>
            <th colspan="5"  rowspan="1"  class="wid100" style="width: 50%"><span style="margin-left: 5px;">用户地址：{{order.userProvice}}{{order.userCity}}{{order.userCounty}}{{order.userTown}}{{order.userAddress}}</span></th>
          </tr>

          <tr>
            <th colspan="2"  rowspan="1" class="wid100" style="width: 20%"><span style="margin-left: 5px;">产品类别：{{order.bigCategoryName}}</span></th>
            <th colspan="2"  rowspan="1" class="wid180" style="width: 20%"><span style="margin-left: 5px;">产品型号：{{order.itemName}}</span></th>
            <th colspan="2"  rowspan="1"  class="wid100" style="width: 20%"><span style="margin-left: 5px;">气源：</span></th>
            <th colspan="1"  rowspan="1" class="wid100" style="width: 10%"><span style="margin-left: 5px;">保内：</span></th>
            <th colspan="3"  rowspan="1" class="wid180" style="width: 30%"><span style="margin-left: 5px;">发票号码：</span></th>
          </tr>
          <tr>
            <th colspan="4"  rowspan="1" class="wid100" style="width: 40%"><span style="margin-left: 5px;">预约上门时间：{{order.bookDate}} {{order.bookDatePeriod}}</span></th>
            <th colspan="6"  rowspan="1" class="wid180" style="width: 60%"><span style="margin-left: 5px;">反馈内容：{{order.appeals}}</span></th>

          </tr>
          <tr v-if="order.serviceType ==1">
            <th colspan="2"  rowspan="1" class="wid100" style="width: 20%"><span style="margin-left: 5px;">报装时间：{{order.wishBookDate}}</span></th>
            <th colspan="2"  rowspan="1" class="wid180" style="width: 20%"><span style="margin-left: 5px;">安装日期：</span>{{order.completeTime}}</th>
            <th colspan="3"  rowspan="1" class="wid100" style="width: 30%"><span style="margin-left: 5px;">安装师傅：</span>{{order.engineerName}}</th>
            <th colspan="3"  rowspan="1" class="wid180" style="width: 30%"><span style="margin-left: 5px;">安装师傅电话：</span>{{order.engineerMobile}}</th>
          </tr>
          <tr v-if="order.serviceType !=1">
            <th colspan="2"  rowspan="1" class="wid100" style="width: 20%"><span style="margin-left: 5px;">报修时间：{{order.wishBookDate}}</span></th>
            <th colspan="2"  rowspan="1" class="wid180" style="width: 20%"><span style="margin-left: 5px;">维修日期：</span>{{order.completeTime}}</th>
            <th colspan="3"  rowspan="1" class="wid100" style="width: 30%"><span style="margin-left: 5px;">维修师傅：</span>{{order.engineerName}}</th>
            <th colspan="3"  rowspan="1" class="wid180" style="width: 30%"><span style="margin-left: 5px;">维修师傅电话：</span>{{order.engineerMobile}}</th>
          </tr>

          <tr v-if="order.serviceType ==1">
            <th colspan="4"  rowspan="1" class="wid100" style="width: 40%"><span style="margin-left: 5px;">包装位置：</span>
              <input type="radio" name="aaa">阳台
              <input type="radio" name="aaa">厨房
              <input type="radio" name="aaa">浴室
              其他：<span></span></th>
            <th colspan="6"  rowspan="1" class="wid180" style="width: 60%"><span style="margin-left: 5px;">处理结果：</span></th>
          </tr>
          <tr v-if="order.serviceType !=1">
            <th colspan="2"  rowspan="1" class="wid100" style="width: 20%"><span style="margin-left: 5px;">维修性质：</span>
              <input type="radio" name="aaa">在点
              <input type="radio" name="aaa">上门
              </th>
            <th colspan="5"  rowspan="1" class="wid180" style="width: 50%"><span style="margin-left: 5px;">产品故障：</span></th>
            <th colspan="3"  rowspan="1" class="wid180" style="width: 30%"><span style="margin-left: 5px;">故障原因：</span></th>
          </tr>
          <tr v-if="order.serviceType !=1">
            <th colspan="4"  rowspan="1" class="wid180" style="width: 40%"><span style="margin-left: 5px;">其他故障原因：</span></th>
            <th colspan="6"  rowspan="1" class="wid180" style="width: 60%"><span style="margin-left: 5px;">处理结果：</span></th>
          </tr>



          </tbody>
        </table>
        <div style="display: flex;text-align: center;">
          <table border="1">
            <thead>

            <tr>

              <th>材料名称</th>
              <th>数量</th>
              <th>金额(元)</th>
              <th colspan="2">相关费用结算</th>


            </tr>
            </thead>
            <tbody>
            <tr>

              <td></td>
              <td></td>
              <td></td>
              <td>上门服务费</td>


              <td></td>

            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>材料费</td>
              <td></td>

            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>路程判定及费用</td>
              <td><span style="display: inline-block;width: 40px;"></span></td>

            </tr>

            </tbody>
          </table>
          <div style="width: 5%;"></div>
          <table border="1">
            <thead>

            <tr>

              <th colspan="8">尊敬的用户：请对我们服务质量进行评价，谢谢！</th>



            </tr>
            </thead>
            <tbody>
            <tr>

              <td colspan="1" style="width: 8%">内容</td>

              <td colspan="7">
                <input type="radio" name="b">非常满意
                <input type="radio" name="b">满意
                <input type="radio" name="b">一般
                <input type="radio" name="b">不满意
                <input type="radio" name="b">非常不满意
              </td>

            </tr>
            <tr>

              <td colspan="1">用户建议</td>

              <td colspan="7">
                <span style="text-align: center">用户签名：</span>
              </td>

            </tr>
            <tr>
              <td colspan="8" style="text-align:left;margin-left: 5px;">服务网点盖章:</td>


            </tr>

            </tbody>
          </table>
        </div>
        <div class="down_" style="margin-top: 10px">尊敬的用户:</div>
        <div class="down_">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;感谢您使用我司产品，如有疑问，请来电，来函投诉。我司一经查实，将对相关人员进行严肃处理，请您给予监督。华帝全国服务热线：400-888-6288</div>


      </div>

    </div>
  </div>
  </el-drawer>
</template>

<script>
import printJS from "print-js";
import api from "@/api/projectApi";
export default {
  name: "printing",
  props: ['multi','param','orderId','orderIds'],
  created() {
    this.currentTime()
    if (this.orderIds!=null){
      this.dataIds = this.orderIds;
    }
    if (this.orderId != null ) {
      this.dataId = this.orderId
    }
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      nowDate:'',
      dataId:'',
      dataIds:[],
      drawer: true,
      orderDates:[]
    };

  },
  methods: {
    currentTime() {
      var date = new Date();
      var year = date.getFullYear(); //月份从0~11，所以加一
      let month = date.getMonth() + 1;
      let day = date.getDate();
      //如果格式是MM则需要此步骤，如果是M格式则此处注释掉
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day<=9){
        day = "0" + day;
      }
      let strDate = year + "-" + month+"-"+day;
      this.nowDate = strDate
    },
    getData(){
      var data
      if (this.orderIds){
        data ={orderIds:this.orderIds}
      }else{
        data ={orderId:this.dataId}
      }
        this.$http({
          url: '/basic/soOrderDispatch/getOrderPrintMsg',
          method: 'post',
          data: data,
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.orderDates = response.data.data
        })
    },
    print() {
      printJS({
        printable: "print", // 标签元素id
        type: "html", // 打印类型
        targetStyles: ["*"],
        style: "@page {margin:0 10mm};", // 可选-打印时去掉眉页眉尾
        ignoreElements: ["no-print"], // 接受打印父 html 元素时应忽略的 html id 数组。
        properties: null,
      });
    },
    handleClose() {
      this.drawer = false;
      this.$emit('closePrint', 1)
    }
  },
};
</script>

<style lang="scss" scope>
#print {
  .container table {
    width: 1000px;
    /* text-align: center; */
    border-color: #000;
    border-collapse: collapse;
    color: black;
  }
  .top2,.down_,.top-img{
    color: black;
  }
  thead {
    color: #000000;
    /* background: rgb(0, 112,192); */
  }

  tbody {
    font-size: 14px;
  }

  tbody td, th {
    padding: 5px 0;
  }

  .wid50 {
    width: 50px;
    text-align: left;
  }

  .wid100 {
    /* width: 100px; */
    text-align: left;
  }
  .wid180 {
    /* width: 180px; */
    text-align: left;
  }
  td {
    margin: 0;
    padding: 0;
    font-weight: 300!important;
  }

  a {
    text-decoration: none;
    color: #08acee;
  }

  button {
    outline: 0;
  }

  img {
    border: 0;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    margin: 0;
    font: inherit;
    color: inherit;
    outline: none;
  }

  li {
    list-style: none;
  }

  a {
    color: #666;
  }

  .clearfix::after {
    clear: both;
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
  }
  .container{
    width: 1100px;
    margin: 100px auto;
    border: 1px solid #f1f1f1;
    padding: 0 50px 10px;
    /* background-color: #e9e9e9; */
  }

  .top-img{
    display: flex;
    position: relative;
    height: 100px;
    margin-top: 20px;
  }
  .title{
    font-size: 24px;
    font-weight: 600;
    margin: 0 200px 0 150px;
  }

  .img2{
     margin-left: 100px;
  }
  .top2{
    display: flex;
    padding: 5px;
    justify-content: space-between;
  }
}
</style>
